export const efaAddressBook = {
  efaAddressBook: {
    noAddresses: 'The business partner you are belonging to hasn\'t got any shipping addresses. Please contact your support team.',
    defaultAddress: 'Default address'
  }
};
